import request from "@/utils/request";

//消息通知列表
export function listSysMessageSend(data) {
    return request({
        url: `/app/send/listSysMessageSend`,
        data,
        method: 'post'
    })
}

//获取消息详情
export function getSysMessageSendById(params) {
    return request({
        url: `/app/send/getSysMessageSendById`,
        params,
        method: 'get'
    })
}

//一键已读
export function ignoreAll(params) {
    return request({
        url: `/app/send/ignoreAll`,
        params,
        method: 'get'
    })
}

